export const routes = [
  {
    webPath: '/dashboard',
    nativePath: '/dashboard',
    type: 'prePost'
  },
];
